/**
 * @engine/input — Normalize Processor
 *
 * Normalizes vector values to unit length.
 */

import type { ProcessorType, ControlValue } from '../types';
import { InputProcessor, registerProcessor } from './InputProcessor';

/**
 * Normalize processor — makes vectors unit length
 */
export class NormalizeProcessor extends InputProcessor {
  readonly type: ProcessorType = 'normalize';

  process(value: ControlValue): ControlValue {
    if (this.isVec2(value)) {
      const mag = Math.sqrt(value.x * value.x + value.y * value.y);
      if (mag < 0.0001) return { x: 0, y: 0 };
      return { x: value.x / mag, y: value.y / mag };
    }

    if (this.isVec3(value)) {
      const mag = Math.sqrt(value.x * value.x + value.y * value.y + value.z * value.z);
      if (mag < 0.0001) return { x: 0, y: 0, z: 0 };
      return { x: value.x / mag, y: value.y / mag, z: value.z / mag };
    }

    // For scalar, just return sign
    if (typeof value === 'number') {
      if (Math.abs(value) < 0.0001) return 0;
      return Math.sign(value);
    }

    return value;
  }
}

registerProcessor('normalize', NormalizeProcessor);
